import { streamerApi } from '@/pages/Donation/api/streamer'

export type GetCryptoAmountProps = {
  baseCurrencyCode?: string
  cryptoAssetCode?: string
  networkCode?: string
  fiatAmount: string
  isIncludeFee: boolean
  username?: string
}

export const getCryptoAmount = async ({
  cryptoAssetCode,
  baseCurrencyCode,
  networkCode,
  fiatAmount,
  isIncludeFee,
  username,
}: GetCryptoAmountProps) => {
  if (!baseCurrencyCode || !cryptoAssetCode || fiatAmount == null || !username) {
    throw Error()
  }

  const response = await streamerApi.calculateCryptoAmount(username, {
    cover_fee: isIncludeFee ?? false,
    nominal_amount: fiatAmount,
    crypto_coin: cryptoAssetCode,
    crypto_network_code: networkCode ?? '',
    nominal_currency: baseCurrencyCode,
  })

  return response?.data
}
